module.exports = __webpack_public_path__ + "img/3화_2수정(4).4cb26053.png";